import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from './cx';
import s from './Card.module.css';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  padding?: 'none' | 'sm' | 'md' | 'lg';
  interactive?: boolean;
}

export function Card({ padding = 'md', interactive, className, ...rest }: CardProps) {
  return <div className={cx(s.card, s[`pad-${padding}`], interactive && s.interactive, className)} {...rest} />;
}

/** Card classes for links and other elements that act as cards. */
export function cardClass(opts: { padding?: CardProps['padding']; interactive?: boolean } = {}): string {
  return cx(s.card, s[`pad-${opts.padding ?? 'md'}`], opts.interactive && s.interactive);
}

export function CardHeader({ title, subtitle, action }: { title: ReactNode; subtitle?: ReactNode; action?: ReactNode }) {
  return (
    <div className={s.header}>
      <div>
        <h2 className={s.title}>{title}</h2>
        {subtitle && <p className={s.subtitle}>{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

/** Stacked sections inside a padding="none" card, separated by dividers. */
export function CardSection({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cx(s.section, className)} {...rest} />;
}
